import UserServices from '@/mixins/services/userServices'

export default {
  mixins: [UserServices],
  data () {
    return {
      fromRoute: null,
      isAutoLogging: false,
      goingTo: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fromRoute = from
    })
  },
  methods: {
    preBack () {
      return true
    },
    /**
    * Handle Back
    * @desc Extends default router back functionality
    * @param {string} fallback - The fallback path if there is no history to use with $router.back(). This is usually the case if the page was visited directly or from another site
    **/
    back (param) {
      let fallback = null
      let npages = 1
      if (isNaN(param)) {
        fallback = param
      } else {
        npages = param
      }

      if (this.preBack()) {
        window.goingBack = true
        if (!fallback || typeof fallback !== 'string') {
          fallback = '/'
        }
        if (!(this.fromRoute && this.fromRoute.name)) {
          this.$router.push(fallback)
        } else {
          if (this.buying) {
            this.buying.pagecount = this.buying.pagecount || 0
            this.buying.pagecount -= npages
          }
          // this.$router.back()
          this.$router.go(-npages)
        }
      }
    },
    goTo (url, replace, isForward) {
      if (isForward === true) {
        window.goingBack = false
      }
      if (replace) {
        this.$router.replace(url)
      } else {
        if (this.buying) {
          this.buying.pagecount = this.buying.pagecount || 0
          this.buying.pagecount++
        }
        this.$router.push(url)
      }
    },
    async ensureAnonymousLogin () {
      return new Promise(async (resolve, reject) => {
        try {
          this.isAutoLogging = true
          this.user = await this._doAnonymousLogin()
          this.isAutoLogging = false
          this.user ? resolve() : reject()
        } catch (e) {
          reject()
        }
      })
    },
    async checkLoginAndGoTo (url, replace, isForward) {
      if (!this.isLogged) {
        try {
          // let email = await simpleDialogCreator({ input: 'Email' })
          this.isAutoLogging = true
          this.loggingFor = url
          this.user = await this._doAnonymousLogin()
          this.isAutoLogging = false
          // this.user.Email = this.user.Email || this.email
          console.log('this.user', this.user)
        } catch (e) {
          this.isAutoLogging = false
          console.warn(e)
          this.internalBus.$emit('notify:error', {
            text: this.dictValue('errorOccured'),
            key: this.notifierKey,
            timeout: 3000
          })
        }
      }
      if (this.isLogged) {
        this.goTo(url, replace, isForward)
        return true
      }
      return false
    },
    async checkFullLoginAndGoTo(url, replace, isForward) {
      /* if (!this.isFullLogged) {
        await loginDialogCreator({ partialAccepted: false }) // l'utente viene salvato dal dialog stesso
      }
      if (this.isFullLogged) {
        this.goTo(url, replace, isForward)
        return true
      }
      return false */
      if (this.isFullLogged) {
        this.goTo(url, replace, isForward)
        return true
      } else {
        this.waitingLoginPage = url
        this.goTo('/login', replace, isForward)
      }
    },
    logout () {
      console.log('logging out from routeControl')
      this.isLogged = false
      // localStorage.removeItem('login_credentials')
      localStorage.removeItem('login_data')
      console.warn('removed login_data and login_credentials')
      // this.back()
      window.history.go('/', true)
    }
  }
}
